/**
 * Contrat « en cours » (B-001).
 * Le jour d'une date ISO est lu dans la chaîne telle que sérialisée par l'API (offset local, ex. +02:00), sans conversion de fuseau.
 * Un contrat est en cours au jour J si (dateDebut vide OU dateDebut <= J)
 * ET (dateFin vide OU dateFin >= J). Comparaison à la journée, sans heure.
 * Un opérateur sans contrat renseigné est masqué, comme un contrat expiré (R-USR-1) :
 * la case « tous les opérateurs » sert aux comptes sans contrat (ex. compte de test).
 */

const pad = (n) => String(n).padStart(2, "0");

/** Clé de jour `YYYY-MM-DD` comparable lexicographiquement, ou null si vide/invalide. */
function cleJour(valeur) {
    if (valeur === null || valeur === undefined || valeur === "") return null;
    if (valeur instanceof Date) {
        if (Number.isNaN(valeur.getTime())) return null;
        return `${valeur.getFullYear()}-${pad(valeur.getMonth() + 1)}-${pad(valeur.getDate())}`;
    }
    if (typeof valeur === "string") {
        // Le jour écrit par l'API (ex. 2026-10-22T00:00:00+02:00) fait foi : on ne le
        // convertit pas de fuseau, sinon il glisserait d'un jour.
        const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(valeur);
        if (m) return `${m[1]}-${m[2]}-${m[3]}`;
        return cleJour(new Date(valeur));
    }
    return null;
}

export function isContratEnCours(contrat, jour = new Date()) {
    if (!contrat) return false;
    const j = cleJour(jour);
    if (!j) return true;
    const debut = cleJour(contrat.dateDebut);
    const fin = cleJour(contrat.dateFin);
    if (debut && debut > j) return false;
    if (fin && fin < j) return false;
    return true;
}

export function filtreOperateursContratEnCours(operateurs, jour = new Date()) {
    return (operateurs ?? []).filter((o) => isContratEnCours(o?.contratTravail, jour));
}
